import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
const enhancedItemsModule = namespace('enhancedItems');
const raritySort = [
    { rarity: 'standard', rank: 0 },
    { rarity: 'premium', rank: 1 },
    { rarity: 'prototype', rank: 2 },
    { rarity: 'advanced', rank: 3 },
    { rarity: 'legendary', rank: 4 },
    { rarity: 'artifact', rank: 5 }
];
let LootEnhancedItems = class LootEnhancedItems extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Enhanced Items';
    }
    created() {
        this.fetchEnhancedItems();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        return _(this.enhancedItems)
            .map(enhancedItem => ({
            ...enhancedItem,
            id: enhancedItem.name,
            isExpandable: enhancedItem.text
        })).value();
    }
    customSort(items, sortBy, sortDesc) {
        items.sort((a, b) => {
            if (sortBy[0] === 'rarityText') {
                if (!sortDesc[0]) {
                    return (_.find(raritySort, ['rarity', a[sortBy[0]]]) || { rank: 0 }).rank <
                        (_.find(raritySort, ['rarity', b[sortBy[0]]]) || { rank: 1 }).rank ? -1 : 1;
                }
                else {
                    return (_.find(raritySort, ['rarity', a[sortBy[0]]]) || { rank: 0 }).rank >
                        (_.find(raritySort, ['rarity', b[sortBy[0]]]) || { rank: 1 }).rank ? -1 : 1;
                }
            }
            else if (sortBy[0] === 'prerequisite') {
                if (!sortDesc[0]) {
                    return (!!a[sortBy[0]]) < (!!b[sortBy[0]]) ? -1 : 1;
                }
                else {
                    return (!!b[sortBy[0]]) < (!!a[sortBy[0]]) ? -1 : 1;
                }
            }
            else {
                if (!sortDesc[0]) {
                    return (a[sortBy[0]]) < (b[sortBy[0]]) ? -1 : 1;
                }
                else {
                    return (b[sortBy[0]]) < (a[sortBy[0]]) ? -1 : 1;
                }
            }
        });
        return items;
    }
    get types() {
        return _(this.items).map(({ type }) => (_.startCase(type))).flattenDeep().compact().sortBy().uniq().value();
    }
    get headers() {
        return [
            { text: 'Name', value: 'name' },
            {
                text: 'Type',
                value: 'type',
                isMultiSelect: true,
                render: _.startCase,
                filterChoices: this.types,
                filterFunction: ({ type }, filterValue) => _.includes(filterValue, _.startCase(type))
            },
            {
                text: 'Subtype',
                value: 'subtype',
                render: _.startCase
            },
            {
                text: 'Rarity',
                value: 'rarityText',
                isMultiSelect: true,
                filterChoices: ['Standard', 'Premium', 'Prototype', 'Advanced', 'Legendary', 'Artifact'],
                render: _.startCase,
                filterFunction: ({ searchableRarity }, filterValue) => _.includes(filterValue, searchableRarity)
            },
            {
                text: 'Prerequisite',
                value: 'prerequisite',
                render: (prerequisite) => prerequisite ? 'Yes' : 'No',
                filterChoices: ['Yes', 'No'],
                filterFunction: ({ prerequisite }, filterValue) => (prerequisite ? 'Yes' : 'No') === filterValue
            },
            {
                text: 'Attunement',
                value: 'requiresAttunement',
                render: (requiresAttunement) => requiresAttunement ? 'Yes' : 'No',
                filterChoices: ['Yes', 'No'],
                filterFunction: ({ requiresAttunement }, filterValue) => (requiresAttunement ? 'Yes' : 'No') === filterValue
            },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: ['EC', 'WH'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    enhancedItemsModule.State
], LootEnhancedItems.prototype, "enhancedItems", void 0);
__decorate([
    enhancedItemsModule.Action
], LootEnhancedItems.prototype, "fetchEnhancedItems", void 0);
LootEnhancedItems = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], LootEnhancedItems);
export default LootEnhancedItems;
